<div class="map-marker-item-container" [attr.data-test-id]="'marker-info-' + index" *ngIf="data">
  <div class="d-flex justify-content-center">
    <a [attr.data-test-id]="'item-name-' + index" [routerLink]="data.routerLink" target="_blank">
      <h5>{{ data.title }}</h5>
    </a>
    <span [attr.data-test-id]="'card-status-badge_' + index" class="text-muted ps-2 mt-1">{{
      getStatusMark() | translate
    }}</span>
  </div>

  <h6 [attr.data-test-id]="'data-location-' + index" [innerHtml]="data.displayedLocation"></h6>
</div>
